// extracted by mini-css-extract-plugin
export default {"form":"forgot-password_form__G-B12"};